<template>
  <div class="letter-sending justify-between flex flex-row">
    <Letters />
  </div>
</template>

<script>
import { Letters } from "react-migration/domains/sites/letters/Letters";

export default {
  components: {
    Letters,
  },
  data: () => ({}),
};
</script>

<style lang="scss">
.letter-sending {
  height: calc(100vh - 52px);
  display: flex;
  flex-direction: row;
  @media (max-width: 640px) {
    flex-direction: column;
  }
}
</style>
